<template>
	<div>
		<!-- page content -->
		<v-row dense class="fill-height ma-0">
			<v-col
				md="3"
				cols="12"
				class="tree-container pt-2 rounded-lg grey lighten-3"
			>
				<!-- search -->
				<div class="d-flex align-center mb-2 px-1">
					<v-autocomplete
						v-model="openItemId"
						:label="$T('inputs.item-name')"
						:items="items"
						:item-text="item => `${item.itemNo}-${item.name}`"
						item-value="id"
						dense
						outlined
						hide-details
						class="me-1"
						@change="activeNode = [openItemId]; selectActiveAccount(openItemId)"
					></v-autocomplete>

					<v-btn
						v-if="permissions.items.isReadWrite"
						depressed
						height="32"
						min-width="0"
						color="primary"
						class="px-2"
						:disabled="disableState"
						:to="{
							name: 'item',
							query: activeNode.length ? { subOf: $route.params.id } : {}
						}"
					>
						<v-icon>$add</v-icon>
						{{$T('add')}}
					</v-btn>
				</div>

				<!-- tree -->
				<v-progress-linear v-if="loading" indeterminate/>
				<bee-treeview
					v-else
					:items="itemsTree"
					dense
					hoverable
					activatable
					class="items-tree"
					root-class="primary--text font-weight-medium"
					active-class="success--text"
					expand-icon="mdi-chevron-down"
					:open-item.sync="openItemId"
					:active.sync="activeNode"
					:open.sync="openNodes"
					calculate-width
					:item-class="item => item.isMix ? 'preview-color--text' : null"
					:disabled="disableState"
					:calculate-threshold="0.9"
					:disable-context-menu="!permissions.items.isReadWrite"
					:context-menu-items="permissions.items.isReadWrite ? contextmenuItems : []"
					@context-menu-edit="item => {
						activeNode = [item.id];
						$router.replace({ name: 'item', params: { id: item.id } })
					}"
					@context-menu-delete="item => {
						activeNode = [item.id];
						$router.replace({ name: 'item', params: { id: item.id }, query: { preview: 1, delete: 1 } })
					}"
					@click="selectActiveAccount"
				>
					<template v-slot:prepend-label="{ item }">
						{{item.itemNo + '-'}}
					</template>
				</bee-treeview>
			</v-col>
			<v-col md="9" cols="12">
				<div
					v-if="$route.name === 'items'"
					class="d-flex flex-column justify-center align-center fill-height"
				>
					<v-img
						src="@/assets/seeds.png"
						max-width="230"
						max-height="230"
						class="mb-2"
					/>
					<p
						class="text-h6 grey--text text--darken-2 ma-0"
					>{{$T('please-select-an-item')}}</p>
				</div>
				<router-view
					v-else
					@change-disable-state="e => disableState = e"
					@update-items="updateItems"
					class="pa-3 py-md-0"
				></router-view>
			</v-col>
		</v-row>
	</div>
</template>

<script>
import { mapState } from 'vuex';
export default {
	name: 'Items',

	data() {
		return {
			loading: false,

			deleteDialog: false,
			
			disableState: false,

			openItemId: null,
			activeNode: [],
			openNodes: [],
		}
	},

	computed: {
		...mapState({
			permissions: state => state.auth.self.permissions,
			items: state => state.items.items,
			itemsTree: state => state.items.itemsTree,
		}),

		contextmenuItems() {
			return [
				{
					title: this.$T('edit'),
					event: 'edit',
					class: 'warning-color--text',
					icon: '$edit',
					iconColor: 'warning-color',
					iconClass: 'me-1'
				},
				{
					title: this.$T('delete'),
					event: 'delete',
					class: 'alert-color--text',
					icon: '$delete',
					iconColor: 'alert-color',
					iconClass: 'me-1'
				}
			]
		}
	},

	methods: {
		selectActiveAccount(data) {
			let item = data;

			if (typeof item === 'number') {
				item = this.items.find(c => c.id === item);
			}
			
			this.openNodes.push(item.id);
			if (this.$route.params.id !== item.id) {
				this.$router.replace({
					name: 'item',
					params: { id: item.id },
					query: { preview: 1 },
				})
			}
		},

		updateItems(id) {
			this.loading = true;
			Promise.all([
				this.$store.dispatch('items/fetchAll'),
				this.$store.dispatch('items/fetchTree'),
			]).then(() => {
				if (id && id !== 'delete') {
					this.openItemId = id;
					this.activeNode.push(id);
					this.$router.replace({ name: 'item', params: { id }, query: { preview: 1 } });
				} else {
					this.$router.replace({ name: 'items' });
				}
			}).finally(() => {
				this.loading = false;
			})	
		},
	},

	created() {
		if (this.$route.params.id) {
			this.openItemId = this.$route.params.id;
			this.activeNode.push(this.$route.params.id);
		}
	}
}
</script>

<style>

</style>